module.exports = __webpack_public_path__ + "img/H5-7.95caf705.png";